/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the ACESFIChapInfoDetails
 *
 * @class ACESFIChapInfoDetails
 */
class ACESFIChapInfoDetails {
  /**
   * Creates an instance of ACESFIChapInfoDetails.
   * @param {*} json
   * @memberof ACESFIChapInfoDetails
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isFiChapAlreadyApplied = json.isFiChapAlreadyApplied;

      // boolean
      this.isChapFundAvailable = json.isChapFundAvailable;

      // boolean
      this.isFIChapFundAvailabe = json.isFIChapFundAvailabe;

      // boolean
      this.isECHAPFundAvailable = json.isECHAPFundAvailable;

      // boolean
      this.isECHAPAlreadyApplied = json.isECHAPAlreadyApplied;

      // boolean
      this.isWSAPFundAvailable = json.isWSAPFundAvailable;
    }
  }
}

export default {
  ACESFIChapInfoDetails,
};
